import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCrt3E3XY7xAcekeJDgoAK0kI50FwXgUwo",
  authDomain: "sageproducts-111f3.firebaseapp.com",
  projectId: "sageproducts-111f3",
  storageBucket: "sageproducts-111f3.firebasestorage.app",
  messagingSenderId: "891875868027",
  appId: "1:891875868027:web:4ca23d5d79f9d38b7191de",
  measurementId: "G-W3FY269QC8",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
